module.exports = __webpack_public_path__ + "static/img/view9-1.217ad86.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view9-1.png
// module id = GgPS
// module chunks = 1